// ترجماتُ المجموعة 6 — تُملأ بترجمة صفحاتها (2026-10-03). المفتاح: النصُّ العربيّ كما في tt().
// team · campaigns · admin · email-box · speed-panel · login · media · date-field
const EN_B6: Record<string, string> = {
  "خطأ في الخادم": "Server error",
  "إبطال هذا المفتاح؟ يتوقّف كلُّ عميلٍ يستعمله فوراً، ولا رجعة.": "Revoke this key? Every client using it stops immediately. This cannot be undone.",
  "اربط Claude ببيانات شركتك: أصدر مفتاحاً ثمّ أضِفه في Claude كموصّل MCP على العنوان": "Connect Claude to your company data: issue a key, then add it in Claude as an MCP connector at",
  "— المفتاح ينوب عن مستخدمٍ من فريقك ولا يرى إلّا ما يراه ذلك المستخدم.": "— the key acts on behalf of a user on your team and sees only what that user can see.",
  "اسم المفتاح (مثال: Claude — مكتبي)": "Key name (e.g. Claude — my office)",
  "ينوب عن (أنت افتراضاً)": "Acts as (you by default)",
  "إصدار مفتاح": "Issue key",
  "انسخه الآن — لن يُعرض مرّةً أخرى": "Copy it now — it won't be shown again",
  "جسر يحفظ تجزئة المفتاح لا نصَّه، فلا سبيل إلى استرجاعه. أضعتَه؟ أبطِله وأصدر غيره.": "Jisr stores a hash of the key, not the key itself, so it cannot be recovered. Lost it? Revoke it and issue a new one.",
  "إخفاء": "Hide",
  "المفتاح": "Key",
  "ينوب عن": "Acts as",
  "آخر استعمال": "Last used",
  "مُبطَل": "Revoked",
  "إبطال": "Revoke",
  "لا مفاتيح بعد": "No keys yet",
  "قبل {n} دقيقة": "{n} min ago",
  "قبل {n} ساعة": "{n} hours ago",
  "قبل {n} يوم": "{n} days ago",
  "مدير النظام": "System admin",
  "استثناء": "Override",
  "تفعيل الكل": "Enable all",
  "عرض فقط": "View only",
  "تعطيل الكل": "Disable all",
  "تم تغيير الدور": "Role changed",
  "على أساس": "based on",
  "تم حفظ الصلاحيات": "Permissions saved",
  "تمت إزالة {n} استثناء": "Removed {n} overrides",
  "لا توجد استثناءات": "No overrides",
  "· اسم المستخدم": "· username",
  "آخر ظهور:": "Last seen:",
  "الدور الأساسي": "Base role",
  "عدّل أساسه أوّلاً": "Change its base first",
  "مدير النظام — كلّ الصلاحيات": "System admin — all permissions",
  "جاري تغيير الدور...": "Changing role...",
  "مدير النظام يملك كل الصلاحيات": "System admin has all permissions",
  "لا يمكن تقييد مدير النظام — لتقييد هذا العضو غيّر دوره أولاً.": "A system admin cannot be restricted — change this member's role first.",
  "حفظ التغييرات": "Save changes",
  "إرجاع إلى صلاحيات الدور الافتراضي": "Reset to default role permissions",
  "تأكيد تغيير الدور": "Confirm role change",
  "مدير النظام يملك كلَّ شيء ويتجاوز كلَّ الصلاحيات المخصّصة والاستثناءات — تأكّد أنّ هذا مقصود.": "System admin owns everything and bypasses all custom permissions and overrides — make sure this is intended.",
  "لا، أعده لصلاحيات الدور": "No, reset to role permissions",
  "نعم احتفظ بها": "Yes, keep them",
  "جارٍ التغيير…": "Changing…",
  "نعم، اجعله مدير النظام": "Yes, make them system admin",
  "تأكيد التغيير": "Confirm change",
  "مراجعة التغييرات": "Review changes",
  "لا توجد تغييرات.": "No changes.",
  "تأكيد الحفظ": "Confirm save",
  "سيتم حذف جميع الاستثناءات الخاصة بـ": "All custom overrides for",
  "والعودة لصلاحيات الدور. هل أنت متأكد؟": "will be removed, reverting to the role's permissions. Are you sure?",
  "جاري التنفيذ...": "Processing...",
  "نعم، أرجعها": "Yes, reset",
  "تعديل صلاحيات:": "Edit permissions:",
  "تعديل الدور:": "Edit role:",
  "تم حفظ الدور": "Role saved",
  "اسم الدور": "Role name",
  "مدير النظام — لا يُبنى عليه دورٌ مخصّص": "System admin — custom roles can't be based on it",
  "الوصف": "Description",
  "وصف مختصر للدور": "Short role description",
  "تم إنشاء الدور": "Role created",
  "إنشاء دور جديد": "Create new role",
  "مثال: محاسب": "e.g. Accountant",
  "مبني على": "Based on",
  "يبدأ الدور الجديد بنسخة من صلاحيات الدور المختار في «مبني على».": "The new role starts with a copy of the permissions of the role chosen in \"Based on\".",
  "إنشاء": "Create",
  "لا توجد صلاحيات حساسة معرّفة.": "No sensitive permissions defined.",
  "الصلاحية": "Permission",
  "الأدوار التي تملكها": "Roles that have it",
  "مستثنون بالسماح": "Allowed by override",
  "ممنوعون": "Denied",
  "الخطورة": "Risk",
  "عالية": "High",
  "متوسطة": "Medium",
  "الدور:": "Role:",
  "الميزة:": "Feature:",
  "أُعيد {n} عضو للدور الأساسي": "{n} members reset to base role",
  "من الموظف #{n}": "From employee #{n}",
  "أُزيل {n} استثناء": "Removed {n} overrides",
  "دور مخصص #{n}": "Custom role #{n}",
  "من {a} إلى {b}": "From {a} to {b}",
  "قبل: {b} — بعد: {a}": "Before: {b} — After: {a}",
  "لا توجد تغييرات مسجلة بعد — أي تعديل على الأدوار أو الصلاحيات سيظهر هنا.": "No changes logged yet — any change to roles or permissions will appear here.",
  "صفحة {p} من {t} — {n} سجل": "Page {p} of {t} — {n} records",
  "فشل إضافة الحساب": "Failed to add account",
  "تمت إزالة العضو": "Member removed",
  "تم نسخ الصلاحيات": "Permissions copied",
  "تم تغيير كلمة المرور بنجاح": "Password changed successfully",
  "فشل تغيير كلمة المرور": "Failed to change password",
  "تم حذف الدور": "Role deleted",
  "بحث بالاسم أو البريد...": "Search by name or email...",
  "كل الأدوار": "All roles",
  "أصحاب صلاحيات مخصصة": "Members with custom permissions",
  "لا توجد نتائج مطابقة — جرّب تعديل البحث أو الفلاتر.": "No matching results — try adjusting your search or filters.",
  "الدور": "Role",
  "آخر ظهور": "Last seen",
  "صلاحيات مخصصة": "Custom permissions",
  "متصل": "Online",
  "مشغول": "Busy",
  "تعديل الصلاحيات": "Edit permissions",
  "إعادة تعيين كلمة المرور": "Reset password",
  "نسخ صلاحيات من موظف آخر": "Copy permissions from another employee",
  "كل الصلاحيات": "All permissions",
  "دور نظام — وصول كامل لجميع الميزات دون استثناء، غير قابل للتعديل.": "System role — full access to all features with no exceptions; cannot be edited.",
  "المستخدمون:": "Users:",
  "دور نظام": "System role",
  "عدد الصلاحيات:": "Permissions:",
  "نسخة": "copy",
  "لا توجد أدوار مخصصة بعد.": "No custom roles yet.",
  "أنشئ دوراً مخصصاً (مثل «محاسب» أو «موظف استقبال») لتجميع صلاحيات فريقك.": "Create a custom role (e.g. \"Accountant\" or \"Receptionist\") to group your team's permissions.",
  "إنشاء دور": "Create role",
  "الوكلاء، الأدوار، الصلاحيات، وسجل التغييرات": "Agents, roles, permissions and change log",
  "إضافة عضو": "Add member",
  "إجمالي الأعضاء": "Total members",
  "متصلون الآن": "Online now",
  "الأدوار المخصصة": "Custom roles",
  "أعضاء بصلاحيات مخصصة": "Members with custom permissions",
  "الأعضاء": "Members",
  "الأدوار": "Roles",
  "الصلاحيات الحساسة": "Sensitive permissions",
  "مفاتيح MCP": "MCP keys",
  "سجل التغييرات": "Change log",
  "حذف الدور": "Delete role",
  "سيتم حذف الدور «{name}».": "The role \"{name}\" will be deleted.",
  "الأعضاء المرتبطون به ({n}) سيعودون إلى دورهم الأساسي.": "Its members ({n}) will return to their base role.",
  "هل أنت متأكد؟ هذا الإجراء لا يمكن التراجع عنه.": "Are you sure? This action cannot be undone.",
  "جاري الحذف...": "Deleting...",
  "حذف عضو": "Delete member",
  "سيتم نسخ الدور وجميع الاستثناءات من الموظف المصدر إلى": "The role and all overrides of the source employee will be copied to",
  "واستبدال صلاحياته الحالية.": "— replacing their current permissions.",
  "الموظف المصدر": "Source employee",
  "اختر موظفاً": "Choose an employee",
  "جاري النسخ...": "Copying...",
  "تم إنشاء الحساب ✅": "Account created ✅",
  "انسخ كلمة المرور وأعطها لـ": "Copy the password and give it to",
  "تظهر مرة واحدة فقط.": "It is shown only once.",
  "البريد الإلكتروني": "Email",
  "اسم المستخدم (يُستعمل بدل البريد)": "Username (can be used instead of email)",
  "تم نسخ كلمة المرور": "Password copied",
  "📧 تم إرسال بيانات الدخول إلى بريد المستخدم.": "📧 Login details were sent to the user's email.",
  "ℹ️ لم يُفعّل إرسال البريد بعد — سلّم كلمة المرور يدوياً. (تُرسل تلقائياً بمجرد تفعيل البريد في الإعدادات.)": "ℹ️ Email sending isn't enabled yet — hand over the password manually. (It will be sent automatically once email is enabled in Settings.)",
  "تغيير كلمة مرور العضو:": "Change password for member:",
  "أدخل كلمة المرور الجديدة": "Enter new password",
  "إضافة عضو جديد": "Add new member",
  "صورة العضو": "Member photo",
  "حذف الصورة": "Remove photo",
  "اضغط لرفع صورة (JPG، PNG، WebP)": "Click to upload a photo (JPG, PNG, WebP)",
  "الاسم الكامل": "Full name",
  "مثال: محمد العتيبي": "e.g. Mohammed Al-Otaibi",
  "لون مميز": "Color",
  "حفظ وإضافة": "Save & add",
  "فشل تحميل الإعلانات": "Failed to load ads",
  "فشل الاتصال": "Connection failed",
  "فشل جلب المجموعات الإعلانية": "Failed to fetch ad sets",
  "أدخل مبلغاً صحيحاً": "Enter a valid amount",
  "فشل تعديل الميزانية": "Failed to update budget",
  "تم تعديل ميزانية المجموعة ✅": "Ad set budget updated ✅",
  "فشل التغيير": "Change failed",
  "تم إيقاف الحملة": "Campaign paused",
  "تم تشغيل الحملة": "Campaign started",
  "تم تعديل الميزانية ✅": "Budget updated ✅",
  "جميع الحقول مطلوبة": "All fields are required",
  "تم إضافة الحساب الإعلاني ✅": "Ad account added ✅",
  "فشل بدء الربط": "Failed to start connection",
  "يرجى السماح بالنوافذ المنبثقة": "Please allow pop-ups",
  "فشل الربط:": "Connection failed:",
  "ما فيه حسابات إعلانية على هذا الحساب — تأكد من منح صلاحية الإعلانات": "No ad accounts on this account — make sure ads permission was granted",
  "اختر الحساب وأدخل اسماً": "Choose an account and enter a name",
  "تم ربط الحساب الإعلاني ✅": "Ad account connected ✅",
  "الحساب الإعلاني غير نشط": "Ad account inactive",
  "لا يوجد حساب إعلاني مضاف": "No ad account added",
  "اربط حساب Facebook للبدء بعرض وإدارة حملاتك الإعلانية على Meta/Instagram": "Connect your Facebook account to view and manage your ad campaigns on Meta/Instagram",
  "🔗 ربط بـ Facebook": "🔗 Connect with Facebook",
  "إضافة يدوي (توكن)": "Add manually (token)",
  "حذف حساب \"{name}\"؟": "Delete account \"{name}\"?",
  "إضافة يدوي": "Add manually",
  "إنشاء إعلان جديد": "Create new ad",
  "إضافة حساب إعلاني جديد": "Add new ad account",
  "الاسم (مثل: كابري)": "Name (e.g. Capri)",
  "🎉 تم الربط بـ Facebook — اختر الحساب الإعلاني": "🎉 Connected to Facebook — choose the ad account",
  "الحساب الإعلاني": "Ad account",
  "اسم مختصر في CRM": "Short name in CRM",
  "حدّث طريقة الدفع في Meta وإلا لن تعمل حملاتك الإعلانية": "Update your payment method in Meta or your ad campaigns won't run",
  "فتح الفوترة": "Open billing",
  "جاري تحميل الإعلانات...": "Loading ads...",
  "لا توجد حملات إعلانية": "No ad campaigns",
  "الإنفاق": "Spend",
  "الوصول": "Reach",
  "النقرات": "Clicks",
  "الميزانية اليومية": "Daily budget",
  "على المجموعات": "On ad sets",
  "إيقاف": "Pause",
  "تشغيل": "Start",
  "الميزانية": "Budget",
  "ميزانية المجموعات": "Ad set budgets",
  "تحميل المجموعات...": "Loading ad sets...",
  "لا توجد مجموعات إعلانية": "No ad sets",
  "إجمالي": "total",
  "فشل تحميل الحملات": "Failed to load campaigns",
  "فشل الإنشاء": "Creation failed",
  "تم إنشاء الحملة": "Campaign created",
  "بدأ إرسال الحملة": "Campaign sending started",
  "تم حذف الحملة": "Campaign deleted",
  "يرجى تعبئة اسم الحملة والرسالة": "Please enter the campaign name and message",
  "الحملات التسويقية": "Marketing Campaigns",
  "إرسال رسائل جماعية عبر واتساب": "Send bulk messages via WhatsApp",
  "إدارة إعلانات Meta / Instagram": "Manage Meta / Instagram ads",
  "حملة جديدة": "New campaign",
  "📢 حملات واتساب": "📢 WhatsApp campaigns",
  "📸 إعلانات Meta": "📸 Meta ads",
  "لا توجد حملات بعد": "No campaigns yet",
  "أنشئ حملتك الأولى": "Create your first campaign",
  "{d}/{t} وصلت": "{d}/{t} delivered",
  "إرسال الآن": "Send now",
  "حذف الحملة؟": "Delete campaign?",
  "التقدم": "Progress",
  "إنشاء حملة جديدة": "Create new campaign",
  "اسم الحملة": "Campaign name",
  "مثال: عروض رمضان 2025": "e.g. Ramadan offers 2025",
  "مرحباً {{customer_name}}، لدينا عرض خاص لك...": "Hello {{customer_name}}, we have a special offer for you...",
  "يمكنك استخدام": "You can use",
  "لإضافة اسم العميل تلقائياً": "to insert the customer's name automatically",
  "تصفية العملاء": "Filter customers",
  "(اتركه فارغاً لإرسال للجميع)": "(leave empty to send to everyone)",
  "سيتم الإرسال للعملاء الذين لديهم وسوم:": "Will be sent to customers with tags:",
  "جدولة الإرسال": "Schedule sending",
  "جدولة الحملة": "Schedule campaign",
  "إنشاء كمسودة": "Create as draft",
  "معدل الوصول": "Delivery rate",
  "تاريخ الإنشاء": "Created at",
  "الشرائح المستهدفة": "Target segments",
  "موعد الإرسال": "Send time",
  "اكتمل في": "Completed at",
  "{n} يوم": "{n} days",
  "{n} ساعة": "{n} hours",
  "تم إرسال التقرير ✅": "Report sent ✅",
  "صحة أجهزة GPS": "GPS device health",
  "آخر فحص:": "Last check:",
  "إرسال تقرير الآن": "Send report now",
  "منقطعة": "Offline",
  "منذ {t}": "{t} ago",
  "ساعة خاطئة / موقع مجمّد ({n})": "Wrong clock / frozen location ({n})",
  "تأخّر {t}": "{t} behind",
  "بطارية احتياطية منخفضة ≤30% ({n}) — أي فصل كهرباء قد يُخفي التتبع": "Low backup battery ≤30% ({n}) — any power cut may hide tracking",
  "البطارية {n}%": "Battery {n}%",
  "لم يتصل بعد ({n}) — مُسنَد ولم يرسل شيئاً قطّ": "Never connected ({n}) — assigned but has never sent anything",
  "كل الأجهزة تعمل بشكل طبيعي": "All devices are working normally",
  "تم الإرسال ✅ ({due} سيارة، {n} مستلم)": "Sent ✅ ({due} vehicles, {n} recipients)",
  "لم يُرسَل — تأكد من إيميل الشركة": "Not sent — check the company email",
  "📤 أرسل التقرير الآن (تجربة)": "📤 Send report now (test)",
  "تم الحفظ ✅": "Saved ✅",
  "تقرير صحة أجهزة GPS": "GPS device health report",
  "أوقات الإرسال (HH:mm مفصولة بفاصلة)": "Send times (HH:mm, comma-separated)",
  "مثال: 09:00,21:00": "e.g. 09:00,21:00",
  "عتبة الانقطاع (ساعات)": "Offline threshold (hours)",
  "الجهاز منقطع لو ما أرسل منذ هذه الساعات": "A device is offline if it hasn't reported for this many hours",
  "عتبة الساعة الخاطئة (ساعات)": "Wrong-clock threshold (hours)",
  "الجهاز مجمّد لو تأخّر توقيته GPS بهذه الساعات": "A device is frozen if its GPS time lags by this many hours",
  "وقت الإرسال اليومي (HH:mm)": "Daily send time (HH:mm)",
  "التحذير قبل الصيانة (كم)": "Warning before maintenance (km)",
  "يُرسَل التنبيه لما يتبقى هذا الكم للصيانة": "The alert is sent when this many km remain until maintenance",
  "📧 تقرير صيانة يومي بالإيميل (PDF بجدول وشعار جسر)": "📧 Daily maintenance report by email (PDF with table and Jisr logo)",
  "وقت الإرسال (HH:mm)": "Send time (HH:mm)",
  "إيميل الشركة (يفصل بينها فاصلة)": "Company email (comma-separated)",
  "التحذير قبل انتهاء التأمين (أيام)": "Warning before insurance expiry (days)",
  "يُرسَل التنبيه قبل انتهاء التأمين بهذه الأيام": "The alert is sent this many days before insurance expires",
  "تم تشغيل {x} ✅": "{x} started ✅",
  "فشل التشغيل": "Run failed",
  "العمليات التلقائية": "Automated operations",
  "هذه العمليات تعمل تلقائياً في الخلفية — يمكن تشغيلها يدوياً هنا.": "These operations run automatically in the background — you can run them manually here.",
  "حالة MSSQL": "MSSQL status",
  "إجمالي السيارات:": "Total vehicles:",
  "متزامنة:": "Synced:",
  "آخر مزامنة:": "Last sync:",
  "أخطاء الخادم الأخيرة ({n})": "Recent server errors ({n})",
  "منذ آخر إعادة تشغيل — للتفاصيل الكاملة: سجلات pm2": "Since last restart — for full details see pm2 logs",
  "لا توجد أخطاء مسجلة ✅": "No errors logged ✅",
  "رجع للنص الافتراضي ↩️": "Reverted to default text ↩️",
  "الرسائل المرسلة": "Outgoing messages",
  "عدّل نص أي رسالة تُرسل للعملاء أو الموظفين. استخدم المتغيرات بين قوسين مثل": "Edit the text of any message sent to customers or staff. Use variables in braces such as",
  "وتُستبدل تلقائياً.": "and they will be replaced automatically.",
  "للعميل": "To customer",
  "للموظف": "To staff",
  "معدّلة": "Customized",
  "استرجاع الافتراضي": "Restore default",
  "تنبيه «عقد بلا فيديو استلام/تسليم»": "\"Contract without pickup/return video\" alert",
  "يُرسَل واتساب + إشعار للموظفين عن كل سيارة طلعت أو رجعت بلا فيديو. القائمة المرئية في صفحة الحجوزات («بلا فيديو») تبقى دائماً.": "A WhatsApp message + notification is sent to staff for every car that left or returned without a video. The visible list on the Bookings page (\"No video\") always remains.",
  "تفعيل تنبيه الواتساب": "Enable WhatsApp alert",
  "المهلة قبل التنبيه (بالساعات بعد خروج/رجوع السيارة)": "Grace period before alert (hours after the car leaves/returns)",
  "المستلمون": "Recipients",
  "لا تختر أحداً = يصل الجميع (مدير/مشرف/وكيل). أو اختر موظفين محددين:": "Select no one = everyone receives it (admin/supervisor/agent). Or pick specific employees:",
  "مسح التحديد (إرسال للجميع)": "Clear selection (send to everyone)",
  "العقود المعلّقة (بلا فيديو)": "Pending contracts (no video)",
  "✅ كل العقود الحديثة عليها فيديو": "✅ All recent contracts have a video",
  "بلا فيديو تأجير": "No rental video",
  "بلا فيديو استلام": "No return video",
  "القائمة حيّة — أول ما يُرفع فيديو العقد يختفي من هنا عند التحديث.": "The list is live — a contract disappears from here on refresh once its video is uploaded.",
  "للمدراء فقط": "Admins only",
  "خطأ ({n})": "Error ({n})",
  "رسالة صادرة": "Outgoing message",
  "رسالة واردة": "Incoming message",
  "تعذّر الاتصال بالخادم": "Couldn't connect to the server",
  "اكتب بريدك الإلكتروني أو اسم المستخدم": "Enter your email or username",
  "جسر": "Jisr",
  "قناة واحدة تصل أعمالك بعملائك": "One channel connecting your business to your customers",
  "تسجيل الدخول": "Sign in",
  "البريد الإلكتروني أو اسم المستخدم": "Email or username",
  "name@company.com أو snm011": "name@company.com or snm011",
  "نسيت كلمة المرور؟": "Forgot password?",
  "جارٍ الدخول...": "Signing in...",
  "ما عندك حساب؟ أنشئ شركتك واشترك ←": "Don't have an account? Create your company and subscribe →",
  "موظف؟ سجّل حضورك من هنا ←": "Employee? Check in here →",
  "جسر · إدارة محادثات الأعمال": "Jisr · Business conversation management",
  "العودة لتسجيل الدخول": "Back to sign in",
  "استعادة كلمة المرور": "Recover password",
  "اكتب بريدك الإلكتروني أو اسم المستخدم وسنرسل كلمة مرور جديدة إلى بريدك المسجّل.": "Enter your email or username and we'll send a new password to your registered email.",
  "جارٍ الإرسال...": "Sending...",
  "تم الإرسال ✅": "Sent ✅",
  "أرسلنا كلمة مرور جديدة إلى": "We sent a new password to",
  "تحقق من صندوق الوارد أو مجلد الرسائل غير المرغوبة": "Check your inbox or spam folder",
  "إعادة الإرسال": "Resend",
  "لا يوجد حساب بهذا البريد": "No account with this email",
  "غير مسجّل لدينا. تأكد من كتابته بشكل صحيح.": "is not registered with us. Make sure it's spelled correctly.",
  "جرّب بريداً آخر": "Try another email",
  "تم تغيير اسم المجلد": "Folder renamed",
  "هل أنت متأكد من حذف هذا الملف؟": "Are you sure you want to delete this file?",
  "تم الحذف بنجاح": "Deleted successfully",
  "تم رفع الملفات بنجاح": "Files uploaded successfully",
  "الوسائط": "Media",
  "رفع": "Upload",
  "مجلد جديد": "New folder",
  "{n} ملف": "{n} files",
  "لا توجد مجلدات — اضغط رفع لإضافة ملفات": "No folders — click Upload to add files",
  "إضافة ملفات": "Add files",
  "لا توجد ملفات في هذا المجلد": "No files in this folder",
  "تحميل الملف": "Download file",
  "رفع ملفات": "Upload files",
  "اسم المجلد": "Folder name",
  "مثال: كيا سيراتو": "e.g. Kia Cerato",
  "اختر صور أو فيديوات": "Choose images or videos",
  "يمكنك اختيار أكثر من ملف": "You can select multiple files",
  "يوم/شهر/سنة": "dd/mm/yyyy",
  "اختيار تاريخ": "Pick a date",
  "أجهزة تحتاج مراجعة": "Devices needing review",
  "ساعة خاطئة": "Wrong clock",
  "مزامنة MSSQL": "MSSQL sync",
  "مزامنة بيانات السيارات والعقود من قاعدة البيانات الخارجية": "Sync vehicle and contract data from the external database",
  "إرسال تنبيهات الصيانة لجميع السيارات المستحقة اليوم": "Send maintenance alerts for all vehicles due today",
  "إرسال تنبيهات التأمين المنتهي أو القريب من الانتهاء": "Send alerts for expired or soon-to-expire insurance",
  "تقرير GPS": "GPS report",
  "إرسال تقرير صحة أجهزة GPS الآن عبر واتساب وإشعار داخلي": "Send the GPS device health report now via WhatsApp and in-app notification",
  "صحة GPS": "GPS health",
  "الأجهزة المنقطعة والمتأخّرة": "Offline and lagging devices",
  "الرسائل": "Messages",
  "نصوص الرسائل المرسلة": "Texts of outgoing messages",
  "مواعيد التقارير والتنبيهات": "Report and alert schedules",
  "تشغيل المهام يدوياً": "Run tasks manually",
  "الحساب الإعلاني معطّل": "Ad account disabled",
  "الحساب غير مسدّد (مشكلة في الدفع)": "Account unsettled (payment issue)",
  "الحساب قيد المراجعة": "Account under review",
  "الحساب معلّق": "Account suspended",
  "الحساب مغلق": "Account closed",
  "الحساب مغلق نهائياً": "Account permanently closed",
  "الحساب محظور": "Account banned",
  "مخالفة سياسات الإعلان": "Ad policy violation",
  "مشكلة في الدفع/البطاقة منتهية": "Payment issue / card expired",
  "نشاط مشبوه": "Suspicious activity",
  "مخالفة الشروط": "Terms violation",
  "مشكلة في الفوترة": "Billing issue",
  "🟢 نشطة": "🟢 Active",
  "⏸ موقوفة": "⏸ Paused",
  "⚫ مؤرشفة": "⚫ Archived",
  "🗑 محذوفة": "🗑 Deleted",
  "مسودة": "Draft",
  "مجدولة": "Scheduled",
  "مكتملة": "Completed",
  "فشلت": "Failed",
  "إجمالي الحملات": "Total campaigns",
  "المرسلة": "Sent",
  "الموصولة": "Delivered",
  "الفاشلة": "Failed",
  "بدون وصول": "No access",
  "عرض وتعديل": "View & edit",
  "تعديل استثناءات موظف": "Edit employee overrides",
  "إرجاع لصلاحيات الدور": "Reset to role permissions",
  "نسخ صلاحيات": "Copy permissions",
  "الرد على الرسالة": "Reply to message",
  "ما فيه إيميل مربوط": "No email connected",
  "اربط إيميلي": "Connect my email",
  "اربط إيميل الشركة": "Connect company email",
  "ما عندك صلاحية على أي إيميل. تواصل مع مدير النظام.": "You don't have access to any email. Contact your system admin.",
  "إيميل الشركة الرئيسي يربطه المدير، ويشوفه كل من عنده صلاحية «الإيميلات».": "The main company email is connected by the admin and visible to everyone with the \"Emails\" permission.",
  "إعدادات الإيميل": "Email settings",
  "بحث في الإيميلات": "Search emails",
  "ما فيه إيميلات": "No emails",
  "اختر إيميلاً لعرضه": "Select an email to view",
  "ردّ": "Reply",
  "اكتب ردّك…": "Write your reply…",
  "جارٍ الإرسال…": "Sending…",
  "إيميل جديد": "New email",
  "إرفاق ملف": "Attach file",
  "تم الإرسال": "Sent",
  "آخر محاولة سحب فشلت:": "Last fetch attempt failed:",
  "إيميلي": "My email",
  "إيميل الشركة": "Company email",
  "الإيميل": "Email",
  "اتركها فارغة للإبقاء على المحفوظة": "Leave empty to keep the saved one",
  "اسم المستخدم (إن اختلف عن الإيميل)": "Username (if different from email)",
  "الاسم الظاهر عند المستلم": "Display name for recipients",
  "خادم الاستلام (IMAP)": "Incoming server (IMAP)",
  "خادم الإرسال (SMTP)": "Outgoing server (SMTP)",
  "شهادة ذاتية التوقيع (خادم داخلي)": "Self-signed certificate (internal server)",
  "اختبار وحفظ": "Test & save",
  "جارٍ اختبار الاتصال…": "Testing connection…",
  "تم ربط الإيميل — السحب الأول يبدأ الحين": "Email connected — first fetch starts now",
  "فك ربط الإيميل": "Disconnect email",
  "فك ربط هذا الإيميل؟ الإيميلات المسحوبة في جسر تنحذف، وصندوقك الأصلي ما يتأثر.": "Disconnect this email? Emails fetched into Jisr will be deleted; your original mailbox is not affected.",
  "أنا": "Me",
  "غير مقروء": "Unread",
  "محتوى الرسالة": "Message content",
  "إخفاء الصور الخارجية": "Hide external images",
  "إظهار الصور الخارجية": "Show external images",
  "توسيع العرض": "Expand view",
  "تصغير العرض": "Collapse view",
  "عرض كنص": "View as text",
  "عرض بالتنسيق": "View formatted",
  "سيتغير دور {name} من {from} إلى {to} — وهذا الموظف لديه استثناءات خاصة. هل تريد الاحتفاظ بها؟": "{name}'s role will change from {from} to {to} — and this member has custom overrides. Keep them?",
  "تغيير دور {name} من {from} إلى {to}؟ تسري الصلاحيات الجديدة فوراً.": "Change {name}'s role from {from} to {to}? The new permissions take effect immediately.",
  "تعديل دور": "Role edited",
  "حذف دور": "Role deleted",
  "تعديل صلاحيات دور": "Role permissions edited",
  "تغيير دور موظف": "Employee role changed",
  "كتابة": "Write",
  "قراءة": "Read",
  "تفعيل الاتصال؟ بعده يمكن إصدار مفتاحٍ يصل به تطبيقٌ خارجيّ إلى بيانات الأدوات المختارة.": "Activate this connection? A key can then be issued that lets an external app reach the selected tools' data.",
  "توسعةٌ أو تغييرُ دور: قد تصل بياناتٌ إضافيّة إلى التطبيق الخارجيّ فوراً. متابعة؟": "Expanding scope or changing the role may expose additional data to the external app immediately. Continue?",
  "إلغاء الاتصال نهائيّاً؟ تتوقّف كلُّ مفاتيحه وروابطه فوراً، ولا رجعة.": "Permanently revoke this connection? All its keys and links stop immediately. This cannot be undone.",
  "اتصالٌ تملكه الشركة: اختر دوراً وأدوات. يعمل التطبيق الخارجيّ بتقاطعهما مع صلاحيّات من يصدر المفتاح — لا بصلاحيّات المدير. العنوان:": "A company-owned connection: pick a role and tools. The external app works with their intersection with the key issuer's permissions — never with admin rights. Endpoint:",
  "اسم الاتصال": "Connection name",
  "أدواتُ الكتابة تسمح للتطبيق بإرسال ردودٍ إلى العملاء وإضافة ملاحظاتٍ وإسناد محادثات.": "Write tools let the app send replies to customers, add notes and assign conversations.",
  "إنشاء مسودّة": "Create draft",
  "الأدوات": "Tools",
  "مفاتيح نشطة": "Active keys",
  "تعليق": "Suspend",
  "إلغاء نهائيّ": "Revoke",
  "لا اتصالات بعد": "No connections yet",
  "اتصالات MCP": "MCP connections",
  "معلّق": "Suspended",
  "مسودّة": "Draft",
  "إصدارُ المفاتيح القديمة متوقّف: المفتاحُ القديم يرى كلَّ ما يراه صاحبُه بلا حدود. أنشئ الربطَ الجديد من تبويب «اتصالات MCP» بدورٍ وأدوات محدّدة، ثمّ أبطل المفتاحَ القديم هنا.": "Issuing legacy keys is stopped: a legacy key sees everything its owner sees, with no limits. Create the new link from the “MCP connections” tab with a specific role and tools, then revoke the legacy key here.",
  "السجل": "Log",
  "لا أحداث بعد": "No events yet",
  "الوقت": "Time",
  "الحدث": "Event",
  "الأداة": "Tool",
  "القرار": "Decision",
  "السبب": "Reason",
};
export default EN_B6;
